













import { Component, Emit, Prop, PropSync, Vue, Model, Watch } from 'vue-property-decorator';
//@ts-ignore
import { shiftDataStore } from '@/store/theoryApiStore/shiftDataModule.ts';

@Component
export default class DraggableEventTimed extends Vue {
  @Prop({type: String, required: true})
  public innerHtml!: string;

  @Prop({type: Boolean, required: true})
  public timed!: boolean;

  @Prop({type: Function, required: true})
  public extendBottom!: (event: any) => void;

  @Prop({type: Object, required: true})
  public event!: any;

  @Watch('event')
  onChangeEvent(newValue: any, oldValue:any) {
    shiftDataStore.assignWeeklyCalendarDom({
      domElement: this.$el,
      eventId: newValue.eventId
    })
  }

  mounted() {
    this.$nextTick(function() {
      shiftDataStore.assignWeeklyCalendarDom({
        domElement: this.$el,
        eventId: this.event.eventId
      })
    })
  }
}
